import React from 'react';

import { useCustomerSection } from '../../hooks';
import { SectionWrapper } from '../SectionWrapper';

import { CustomerLegend } from './components/Legend';
import { CustomerTable } from './components/Table';

interface CustomerProps {}

export const Customer: React.FC<CustomerProps> = () => {
  const {
    itemCount,
    filterCount,
    clearSelectionButtonIsDisabled,
    filterButtonIsDisabled,
    orderButtonIsDisabled,
    searchInputProps,
    handlePressClearSectionButton,
    handlePressFilterButton,
    handlePressBasketButton,
    error,
    isLoading,
    isLoadingMore,
    orderBy,
    refresher,
    response,
    onEndReached,
    skeletonItemCount,
    customerCartStatus,
    sectionTitle,
    handleAddCustomers,
    errorTags,
    isLoadingTags,
    refresherTags,
  } = useCustomerSection();

  return (
    <SectionWrapper
      title={sectionTitle}
      status={customerCartStatus}
      itemCount={itemCount}
      filterCount={filterCount}
      onPressFilterButton={handlePressFilterButton}
      onPressClearSelectionButton={handlePressClearSectionButton}
      onPressBasketButton={handlePressBasketButton}
      onAdd={handleAddCustomers}
      onEdit={handlePressBasketButton}
      tableComponent={
        <CustomerTable
          isLoading={isLoading}
          orderBy={orderBy}
          refresher={refresher}
          response={response}
          isLoadingMore={isLoadingMore}
          error={error}
          onEndReached={onEndReached}
          skeletonItemCount={skeletonItemCount}
          errorTags={errorTags}
          isLoadingTags={isLoadingTags}
          refresherTags={refresherTags}
        />
      }
      legendComponent={<CustomerLegend />}
      orderButtonIsDisabled={orderButtonIsDisabled}
      filterButtonIsDisabled={filterButtonIsDisabled}
      clearSelectionButtonIsDisabled={clearSelectionButtonIsDisabled}
      searchInputProps={searchInputProps}
    />
  );
};
